<template>
  <div>
    <!-- Fondo oscuro -->
    <div v-show="isVisible" class="overlay" @click.stop></div>

    <!-- Modal -->
    <v-card v-show="isVisible" class="payment-modal" @click.stop>
      <div class="modal-header">
        <button
          class="close-btn"
          @click="close"
          style="position: absolute; top: 8px; right: 8px; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;"
          aria-label="Cerrar"
        >
          &times;
        </button>
      </div>

      <div class="modal-content">
        <Loading v-if="isLoading" />
        <!-- Wrapper (mismo selector que usas en el otro modal) -->
        <div v-else id="toku-container" class="toku-container-wrapper">
          <iframe
            id="toku-frame"
            :src="tokuUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="modal-footer" style="padding: 16px; border-top: 1px solid #eee; text-align: right">
        <button type="button" class="btn btn-secondary" @click="backStepOne">
          Volver
        </button>
      </div>
    </v-card>
  </div>
</template>

<script>
import Loading from "../isep/Tools/loading.vue";

export default {
  name: "ModalTokuDomiciliacion",
  components: { Loading },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      tokuUrl: "",
    };
  },
  methods: {
    backStepOne(){
      // this.$router.push("/pago-en-linea/paso-1");
      window.location.reload()
    },
    // Llama esto desde el padre pasando la URL ya obtenida del endpoint
    openWithUrl(url) {
      this.tokuUrl = url || "";
      this.isVisible = true;
      document.body.style.overflow = "hidden";
      this.isLoading = !this.tokuUrl;
      this.$nextTick(() => {
        // si hay URL, quitamos el loader
        if (this.tokuUrl) this.isLoading = false;
      });
    },
    close() {
      this.isVisible = false;
      document.body.style.overflow = "";
      // (opcional) limpia la URL al cerrar
      this.tokuUrl = "";
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.payment-modal {
  /* 1) Convierto la tarjeta en un contenedor flex vertical */
  display: flex;
  flex-direction: column;

  /* el resto de tus reglas */
  width: 90vw;
  max-width: 600px;
  min-width: 300px;

  height: 80vh;
  max-height: 700px;
  min-height: 540px;

  margin: auto;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;

  /* evito scroll en la tarjeta principal */
  overflow: hidden;
}

.modal-content {
  border: none;
}
.modal-header {
  flex: 0 0 auto;
}
.modal-content {
  flex: 1 1 auto;
  padding: 0;
  display: flex;
  overflow: hidden;
}

/* 4) El wrapper del SDK crece para llenar */
.toku-container-wrapper {
  flex: 1 1 auto;
  /* por si acaso */
  width: 100%;
  height: 100%;
}

::v-deep #toku-frame {
  width: 100% !important;
  height: 100% !important;
  border: none;
  overflow: hidden;
}

.modal-title {
  color: #003366;
  font-size: 18px;
  font-weight: bold;
}

.payment-option {
  background-color: #f0f0f0;
  margin-bottom: 10px;
}

.payment-option:hover {
  background-color: #e0e0e0;
}

.amount-text {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
}

.cancel-btn {
  background-color: #03132b !important;
  color: white;
}

.confirm-btn {
  background-color: #28a745 !important;
  color: white;
}
.error-btn {
  background-color: #a72828 !important;
  color: white;
}
</style>
